import React, { useContext } from "react";
import { cancel } from "../../../../assets/icons";
import SmallButton from "../../../../components/button/SmallButton";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Input from "../../../../components/input/Input";
import SetQueryString from "../../../../utils/query_searchParams/SetQueryString";
import { useHistory, useLocation } from "react-router-dom";
import SizingContext from "../../../../store/sizing/SizingContext";
import { ActionType } from "../../../../store/sizing/action";
import { loadOptionsCategory } from "../../../../utils/loadOption/LoadOption";
import { queryparamsSizing } from "../../helpers/list";

const genderOptions: any[] = [
  { value: "0", label: "Men" },
  { value: "1", label: "Women" },
  { value: "2", label: "Youth" },
  { value: "3", label: "Infant" },
  { value: "5", label: "Unisex" },
];

const SizingFilter = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { SizingDispatch } = useContext(SizingContext);

  const handleShowFilter = () => {
    SizingDispatch({ type: ActionType.ShowFilter });
  };

  const handleChangeFilter = (event: any, default_name?: string) => {
    let name;
    let value;
    if (!event?.label) {
      name = event.target.name;
      value = event.target.value;
    } else {
      value = event.value;
      name = default_name;
    }
    SetQueryString(queryparamsSizing, value, name, search, pathname, history);
  };

  const applyFilter = () => {
    setTimeout(() => SizingDispatch({ type: ActionType.ShowFilter }), 500);
  };

  return (
    <div className="fixed z-50 cursor-pointer h-full inset-0 flex justify-center md:items-center items-start bg-black bg-opacity-70">
      <div className="bg-white md:rounded-lg cursor-default rounded-t-none rounded-b-lg overflow-hidden h-3/4 shadow-xl transform transition-all md:w-1/2 w-full">
        <div className="px-10 py-7 flex justify-between items-center w-full h-1/6">
          <h1
            className="md:text-2xl text-lg leading-6 font-medium text-textPrimary"
            id="modal-headline"
          >
            Filter
          </h1>
          <img
            src={cancel}
            alt="back"
            className="cursor-pointer md:w-5 w-3"
            onClick={handleShowFilter}
          />
        </div>
        <hr className="w-full" />
        <div className="h-4/6 overflow-y-auto">
          <div className="flex px-10 items-center md:h-1/3">
            <div className="w-full md:my-0 my-3">
              <h1 className="md:text-base text-sm text-textPrimary">
                Product Category
              </h1>
              <AsyncSelect
                cacheOptions
                defaultOptions
                isSearchable={true}
                loadOptions={loadOptionsCategory}
                onChange={(e) => handleChangeFilter(e, "product_category")}
                className="my-3.5 font-rom text-sm"
              />
            </div>
          </div>
          <hr className="w-full" />
          <div className="flex w-full px-10 items-center md:h-1/3">
            <div className="w-full md:my-0 my-3">
              <h1 className="md:text-base text-sm text-textPrimary">Gender</h1>
              <Select
                isSearchable={true}
                className="my-3.5 font-rom text-sm"
                options={genderOptions}
                onChange={(e) => handleChangeFilter(e, "gender")}
              />
            </div>
          </div>
          <hr className="w-full" />
          <div className="grid grid-cols-2 gap-8 w-full px-10 md:my-0 my-3 items-center md:h-1/3">
            <div className="w-full">
              <h1 className="md:text-base text-sm text-textPrimary">
                Add Time (from)
              </h1>
              <Input
                type={"date"}
                name={"add_time_from"}
                handleChange={handleChangeFilter}
              />
            </div>
            <div className="w-full">
              <h1 className="md:text-base text-sm text-textPrimary">
                Add Time (to)
              </h1>
              <Input
                type={"date"}
                name={"add_time_to"}
                handleChange={handleChangeFilter}
              />
            </div>
          </div>
        </div>
        <hr className="w-full" />
        <div className="flex justify-center items-center h-1/6">
          <SmallButton
            type={"button"}
            color={"bg-primary"}
            height={10}
            textColor={"text-white"}
            hoverColor={"bg-red-300"}
            handleClick={applyFilter}
            text={"Apply"}
            loadColor={"white"}
          />
        </div>
      </div>
    </div>
  );
};

export default SizingFilter;
